import {
  type ISalesTeamReassign,
  useGetSalesTeamPermissionMessages,
  useGetSalesTeamsByBranch,
  useGetSalesTeamUsers,
} from '@user/store/salesTeam'
import { useGetSalesTeamPositionsData } from '@user/store/authorization'
import { useGetSalesTeamInputLabel } from '@user/components/Settings/SalesTeams/hooks'
import { useFormikContext } from 'formik'
import { useGetCrossBranchValidation } from '@user/store/lead/hooks/useGetCrossBranchValidation'
import { ENTITY_TYPES } from '@sales-center/common'
import { useGetSalesTeamList } from '@user/store/salesTeam/hooks/useGetSalesTeamListOnMount'

interface Props {
  salesTeam: ISalesTeamReassign
  entityType: ENTITY_TYPES
  entityId: number
}

export function useData(props: Props) {
  const { salesTeam, entityId, entityType } = props
  const { branch } = salesTeam

  const {
    values: { teamId, ownerId },
  } = useFormikContext<{ teamId: number; ownerId: string }>()

  const { status, salesTeams } = useGetSalesTeamList({
    includeTeamsByBranchId: true,
  })

  const salesTeamsForUser = salesTeams
  const salesTeamsByBranch = useGetSalesTeamsByBranch(salesTeam.branchId)

  const positionsDataStatus = useGetSalesTeamPositionsData()

  const { execute: loadSalesTeamUsers, status: usersStatus } =
    useGetSalesTeamUsers(teamId)

  const { crossBranchValidation, crossBranchValidationStatus } =
    useGetCrossBranchValidation(entityId, entityType)

  const infoTextValue = `You can re-assign to any team/owner associated with the branch: ${branch}`

  const { positionBasedAccessText, selectedSalesTeamAccessText } =
    useGetSalesTeamPermissionMessages(positionsDataStatus, teamId, ownerId)

  const selectedLabel = useGetSalesTeamInputLabel(teamId, salesTeamsForUser)

  const isOpportunity = entityType == ENTITY_TYPES.Opportunity

  return {
    selectedLabel,
    positionBasedAccessText,
    selectedSalesTeamAccessText,
    infoTextValue,
    salesTeamsForUser,
    teamStatus: status,
    loadSalesTeamUsers,
    usersStatus,
    crossBranchValidation,
    crossBranchValidationStatus,
    teamId,
    salesTeamsByBranch,
    positionsDataStatus,
    isOpportunity,
  }
}
